export default {
  "menu.CompanyScoreOperateRecordCreateRectificationRecordFormPage": "发起整改",
}